import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "@/services/api";

export const getTicketsList = createAsyncThunk(
    "ticket/getTicketsList",
    async (params, { rejectWithValue }) => {
        try {
            const tab = params.tab || "pending";
            const search = params.search || "";
            const sort_order = params.sort_order || "desc";
            const per_page = params.per_page || 10;
            const page = params.page || 1;

            const response = await api.get(
                `admin/get-tickets-list?tab=${tab}&search=${search}&sort_order=${sort_order}&per_page=${per_page}&page=${page}`
            );

            return response.data;
        } catch (err) {
            return rejectWithValue(
                err.response?.data || "Failed to fetch tickets."
            );
        }
    }
);

export const getSalesManagersList = createAsyncThunk(
    "ticket/getSalesManagersList",
    async (_, { rejectWithValue }) => {
        try {
            const response = await api.get("admin/get-sales-manager");
            return response.data;
        } catch (err) {
            return rejectWithValue(
                err.response?.data || "Failed to fetch sales managers."
            );
        }
    }
);

export const assignTicket = createAsyncThunk(
    "ticket/assignTicket",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await api.post(
                "admin/assign-ticket-to-sales",
                payload
            );

            return response.data;
        } catch (err) {
            return rejectWithValue(
                err.response?.data || "Failed to assign ticket."
            );
        }
    }
);

export const updateTicketStatus = createAsyncThunk(
    "ticket/updateTicketStatus",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await api.post("admin/update-ticket-status", payload);
            return response.data;
        } catch (err) {
            return rejectWithValue(
                err.response?.data || "Failed to update ticket status."
            );
        }
    }
);

const ticketSlice = createSlice({
    name: "ticket",
    initialState: {
        ticketsData: {
            tickets: [],
            pagination: {
                current_page: 1,
                last_pages: 1,
                per_page: 10,
                total: 0
            },
            counts: {
                total: 0,
                pending: 0,
                in_process: 0,
                completed: 0
            }
        },
        loading: false,
        list_loading: false,
        selectedTicketId: null,
        managersList: [],
    },
    reducers: {
        setSelectedTicket(state, action) {
            state.selectedTicketId = action.payload;
        },
        resetTicketStatus(state) {
            state.loading = false;
            state.list_loading = false;
        },
    },
    extraReducers: (builder) => {
            builder
                .addCase(getTicketsList.pending, (state) => {
                    state.list_loading = true;
                })
                .addCase(getTicketsList.fulfilled, (state, action) => {
                    state.list_loading = false;
                    const incomingPage = action.payload?.pagination?.current_page || 1;

                    if (incomingPage === 1) {
                        state.ticketsData = {
                            tickets: action.payload?.tickets || [],
                            pagination: action.payload?.pagination || {
                                current_page: 1,
                                last_pages: 1,
                                per_page: 10,
                                total: 0
                            },
                            counts: action.payload?.counts || {
                                total: 0,
                                pending: 0,
                                in_process: 0,
                                completed: 0
                            }
                        };
                    } else {
                        state.ticketsData = {
                            pagination: action.payload?.pagination || {},
                            counts: action.payload?.counts || state.ticketsData.counts,

                            tickets: [
                                ...(state.ticketsData?.tickets || []),
                                ...(action.payload?.tickets || []),
                            ],
                        };
                    }
                })
                .addCase(getTicketsList.rejected, (state) => {
                    state.list_loading = false;
                })
                .addCase(getSalesManagersList.fulfilled, (state, action) => {
                    state.managersList = action.payload || [];
                })

                .addMatcher(
                    (action) => action.type.startsWith("ticket/") && action.type.endsWith("/pending"),
                    (state) => { state.loading = true; }
                )
                .addMatcher(
                    (action) => action.type.startsWith("ticket/") && action.type.endsWith("/fulfilled"),
                    (state) => { state.loading = false; }
                )
                .addMatcher(
                    (action) => action.type.startsWith("ticket/") && action.type.endsWith("/rejected"),
                    (state) => { state.loading = false; }
                );
        },
});

export const { setSelectedTicket, resetTicketStatus } = ticketSlice.actions;
export default ticketSlice.reducer;